import Marquee from "react-fast-marquee";
import { useLanguage } from "../i18n/LanguageContext";

export default function MarqueeRibbon() {
  const { t } = useLanguage();
  const items = t("marquee");

  return (
    <div
      data-testid="marquee-ribbon"
      className="border-y border-navy bg-[#F7F5F0] overflow-hidden py-5"
    >
      <Marquee speed={40} gradient={false} pauseOnHover>
        {items.concat(items, items).map((item, i) => (
          <span
            key={i}
            className="heading-display text-4xl md:text-5xl mx-10 flex items-center"
          >
            <span className={i % 2 === 0 ? "italic text-ink" : ""}>{item}</span>
            <span className="mx-10 text-navy">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
